import React from 'react'
import styled from 'styled-components'

const IconWrapper = styled.div`
  margin-top: 60px;

  svg {
    margin-bottom: -10px;
    height: 36px;
    width: 300px;

    @media (min-width: 960px) {
      margin-bottom: -30px;
      height: 103px;
      width: 851px;
      
  }
`

const Annotations = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  width: 280px;
  margin: 0 auto;

  @media (min-width: 960px) {
    width: 740px;
    font-size: 25px;
  }
`

const Timeline = () => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 850.811 103.363"
    >
      <defs>
        <clipPath id="clip-path-3">
          <rect
            id="Rectangle_56"
            data-name="Rectangle 56"
            width="108.148"
            height="41.202"
            fill="#fff"
          />
        </clipPath>
        <clipPath id="clip">
          <use xlinkHref="#fill" />
        </clipPath>
      </defs>

      <g
        id="Rectangle_258"
        data-name="Rectangle 258"
        transform="translate(89.5 42.118)"
        fill="none"
        stroke="#fff"
        strokeWidth="32"
      >
        <rect id="fill" width="675.711" height="1.833" stroke="none" />
        <path
          d="M0,-14.166980385780334h675.7113647460938M659.7113647460938,0v1.8330196142196655M675.7113647460938,16h-675.7113647460938M16,1.8330196142196655v-1.8330196142196655"
          fill="none"
          clipPath="url(#clip)"
        />
      </g>
      <circle
        id="Ellipse_34"
        data-name="Ellipse 34"
        cx="10.082"
        cy="10.082"
        r="10.082"
        transform="translate(79.418 32.953)"
        fill="#fff"
      />
      <g id="Group_190" data-name="Group 190" transform="translate(462.373)">
        <g id="Group_33" data-name="Group 33" clipPath="url(#clip-path-3)">
          <path
            id="Path_9"
            data-name="Path 9"
            d="M9.223,2.687C8.757,4.145,8.688,5.146,8.177,5.8c-1.23,1.573-2.7,2.959-4.014,4.468a11.812,11.812,0,0,0-3.21,8.727c.13,2.829-.849,5.691-.942,8.552C-.158,32.8,1.547,34.787,6.85,35.4a4.7,4.7,0,0,1,3.771,2.267A7.779,7.779,0,0,0,23.743,37.5,3.844,3.844,0,0,1,27.6,35.537q25.279.075,50.559,0a3.923,3.923,0,0,1,3.887,1.9c3.409,5.146,9.956,4.93,13.567-.126a5.737,5.737,0,0,1,2.995-1.7c2.813-.819,9.373.627,9.532-3.707a29.906,29.906,0,0,0-.983-7.23c-2-9.305-9.953-9.86-17.127-11.387-3.219-.685-6.542-.872-9.8-1.384a6.923,6.923,0,0,1-3.055-1.027A52.588,52.588,0,0,0,48.271.3C35-.623,21.861.679,9.223,2.687"
            transform="translate(0 0)"
            fill="#fff"
          />
        </g>
      </g>
      <circle
        id="Ellipse_31"
        data-name="Ellipse 31"
        cx="10.082"
        cy="10.082"
        r="10.082"
        transform="translate(750.547 32.953)"
        fill="#fff"
      />
    </svg>
    <Annotations>
      <div>2006</div>
      <div>Today</div>
    </Annotations>
  </IconWrapper>
)

export default Timeline
